import React from 'react';
import { createPortal } from 'react-dom';
import Modal from '../common/Modal/Modal';
import { ExVesselValueChart } from '../FisheryCharts/FisheryCharts';

export interface ExVesselValueModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: unknown[];
  loading?: boolean;
  error?: string | null;
  stockName?: string;
}

function isAllZero(data: unknown[], keys = ['actual', 'potential']): boolean {
  if (!data?.length) return true;
  return data.every((d) => {
    const obj = d as Record<string, unknown>;
    return keys.every((key) => obj[key] === 0 || obj[key] === null || obj[key] === undefined);
  });
}

export default function ExVesselValueModal({
  isOpen,
  onClose,
  data,
  loading = false,
  error = null,
  stockName = 'All Stocks',
}: ExVesselValueModalProps): React.ReactElement | null {
  if (!isOpen) return null;

  const displayName = stockName === 'all stocks' || !stockName ? 'All Stocks' : stockName;

  return createPortal(
    <Modal
      title={`EX VESSEL VALUE: ${displayName}`}
      onClose={onClose}
      size="extra-large"
      transparentBackdrop={true}
      parameterStyle={true}
      {...({ customMaxWidth: '90vw', customMaxHeight: '90vh' } as Record<string, unknown>)}
      bodyStyle={{ padding: '20px' }}
    >
      {loading ? (
        <p className="noscroll-loading-message">Loading data...</p>
      ) : error ? (
        <p className="noscroll-error-message">{error}</p>
      ) : !data.length || isAllZero(data) ? (
        <p className="noscroll-no-data-message">Data deficient</p>
      ) : (
        <ExVesselValueChart
          {...({ data, maxHeight: 400 } as React.ComponentProps<typeof ExVesselValueChart>)}
        />
      )}
    </Modal>,
    document.body
  );
}
